
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"48","rx":"6","fill":"#EAE3F2"}}),_c('g',{attrs:{"clip-path":"url(#clip0_315_107527)","fill":"#481D72"}},[_c('path',{attrs:{"d":"M21.75 13.512a3 3 0 00-3 3 .75.75 0 01-.75.75h-3.75a.75.75 0 00-.75.75v15.75a.75.75 0 00.75.75h7.5a.75.75 0 010 1.5h-7.5a2.25 2.25 0 01-2.25-2.25v-15.75a2.25 2.25 0 012.25-2.25h3.063a4.5 4.5 0 018.874 0h3.063a2.25 2.25 0 012.25 2.25v2.25a.75.75 0 01-1.5 0v-2.25a.75.75 0 00-.75-.75H25.5a.75.75 0 01-.75-.75 3 3 0 00-3-3z"}}),_c('path',{attrs:{"d":"M16.5 22.512a.75.75 0 01.75-.75h5.25a.75.75 0 010 1.5h-5.25a.75.75 0 01-.75-.75zM16.5 26.262a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM17.25 29.262a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3zM20.954 15.341a1.125 1.125 0 111.591 1.591 1.125 1.125 0 01-1.59-1.59zM32.524 27.967a.75.75 0 10-1.2-.9L28.42 30.94h-.002l-1.5-1.5a.75.75 0 00-1.06 1.061l1.5 1.5a1.5 1.5 0 002.26-.16l2.906-3.874z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.477 24.489a6.75 6.75 0 119.546 9.547 6.75 6.75 0 01-9.546-9.547zm4.773-.477a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_315_107527"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(12 12)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    